import { CurrencyPipe, DatePipe } from '@angular/common';

export function formatAutoPayDate(pipe: DatePipe, date: Date): string {
  return pipe.transform(date, 'yyyy-MM-dd', undefined, 'en-US');
}

export function formatAutoPayAmount(pipe: CurrencyPipe, amount: number): string {
  return pipe.transform(amount, 'USD', 'symbol', '1.2-2', 'en-US');
}
